const clean = (value) => String(value ?? "").replace(/\s/g, "").toUpperCase();

export const validateIBAN = (value) => {
  if (!value) return true;
  const iban = clean(value);

  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/.test(iban)) return false;

  const rearranged = iban.slice(4) + iban.slice(0, 4);

  const numeric = rearranged
    .split("")
    .map((c) => (/[A-Z]/.test(c) ? c.charCodeAt(0) - 55 : c))
    .join("");

  let remainder = 0;
  for (let i = 0; i < numeric.length; i += 7) {
    remainder = parseInt(String(remainder) + numeric.slice(i, i + 7), 10) % 97;
  }

  return remainder === 1;
};
export const validateVAT   = (v) => !v || /^NL\d{9}B\d{2}$/.test(clean(v));
export const validateKvK   = (v) => !v || /^\d{8}$/.test(clean(v));
export const validateGST   = (v) => !v || /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}Z[A-Z\d]{1}$/.test(clean(v));
export const validateIFSC  = (v) => !v || /^[A-Z]{4}0[A-Z0-9]{6}$/.test(clean(v));
export const validateAccountNumber = (v) => !v || /^\d{9,18}$/.test(clean(v));
export const validateGAccount = (v) => !v || validateIBAN(v);